<template>
  <div>
    <div class="sessions">
      <div class="nope" v-if="!sessions.length">Сессий нет</div>

      <template v-else>
        <div class="last session">
          <uiBlockTitle>Последняя сессия</uiBlockTitle>
          <div v-if="last.city">{{ last.city }}</div>
          <div>IP: {{ last.ip || 'Нет' }}</div>
          <div>Девайс: {{ last.device || 'Нет' }}</div>
          <div>
            Версия: {{ last?.appVersion?.name || '–' }}
            <span v-if="last?.appVersion?.code">
              ({{ last.appVersion.code }})
            </span>
          </div>
          <div>Пушик: {{ last.pushType || 'Нет' }}</div>
          <div>
            Апдейт: {{ formatDate(last.updated) }} ({{ distance(last.updated) }}
            назад)
          </div>
          <div v-if="last.created">
            Создана: {{ formatDate(last.created) }} ({{
              distance(last.created)
            }}
            назад)
          </div>
        </div>

        <uiFold
          :title="`Другие сессии (${sessions.length - 1})`"
          :small="true"
          v-if="sessions.length > 1"
        >
          <div
            class="session"
            v-for="session in sessions.slice(1)"
            :key="session._id"
          >
            <div v-if="session.city">{{ session.city }}</div>
            <div>IP: {{ session.ip || 'Нет' }}</div>
            <div>Девайс: {{ session.device || 'Нет' }}</div>
            <div>
              Версия: {{ session?.appVersion?.name || '–' }}
              <span v-if="session?.appVersion?.code">
                ({{ session.appVersion.code }})
              </span>
            </div>
            <div>Пушик: {{ session.pushType || 'Нет' }}</div>
            <div>
              Апдейт: {{ formatDate(session.updated) }} ({{
                distance(session.updated)
              }}
              назад)
            </div>
            <div v-if="session.created">
              Создана: {{ formatDate(session.created) }} ({{
                distance(session.created)
              }}
              назад)
            </div>
          </div>
        </uiFold>
      </template>
    </div>
  </div>
</template>

<script>
import { API } from '@/config'
import { format, formatDistanceToNow } from 'date-fns'
import { ru } from 'date-fns/locale'

export default {
  name: 'UserSessions',
  props: {
    id: String
  },
  data () {
    return {
      loading: false,
      sessions: []
    }
  },
  computed: {
    last () {
      return this.sessions[0]
    },
    other () {
      return this.sessions
    }
  },
  watch: {
    id () {
      this.sessions = []
      this.load()
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      if (this.loading) return
      this.loading = true

      let { data } = await this.$http.post(API.USERS.sessions, {
        id: this.id
      })
      if (!data || data.err) {
        this.$notify(data.err)
        return (this.loading = false)
      }

      this.sessions = data.sort(
        (a, b) => new Date(b.updated) - new Date(a.updated)
      )
      this.$emit('loaded', data.length)

      if (this.last) {
        let payload = {
          time: this.distance(this.last.updated),
          city: this.last.city
        }
        this.$emit('lastsession', payload)
      }
      this.loading = false
    },
    formatDate (d) {
      return format(new Date(d), 'dd.MM.yyyy в HH:mm')
    },
    distance (d) {
      return formatDistanceToNow(new Date(d), { locale: ru })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.session {
  height: fit-content;
  margin-bottom: 10px;
  font-size: 13px;
}

.nope {
  text-align: center;
  padding: 10px 0;
  padding-bottom: 20px;
  opacity: 0.5;
}
</style>
